// tslint:disable:max-line-length
import { Component } from '@angular/core';

@Component({
  selector: 'pmd-timepicker',
  template: `
    <div class="pmd-timepicker-container">
      <div class="pmd-timepicker-controls">
        <button class="pmd-decrease" type="button">-</button>
        <input type="text" [value]="hours" placeholder="00" />
        <button class="pmd-increase" type="button">+</button>
      </div>
      <div class="pmd-timepicker-controls">
        <button class="pmd-decrease" type="button">-</button>
        <input type="text" [value]="minutes" placeholder="00" />
        <button class="pmd-increase" type="button">+</button>
      </div>
      <button class="switch-time-format" type="button">
        {{ ampm }}
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKCAYAAABi8KSDAAABSElEQVQYV3XQPUvDUBQG4HNuagtVqc6KgouCv6GIuIntYBLB9hcIQpLStCAIV7DYmpTcRWcXqZio3Vwc/UCc/QEqfgyKGbr0I7nS1EiHeqYzPO/h5SD0jaxUZjmSLCB+OFb+UFINFwASAEAdpu9gaGXVyAHHFQBkHpKHc6a9dzECvADyY9sqlAMsK9W0jzxDXqeytr3mhQckxSji27TJJ5/rPmIpwJJq3HrtduriYOurv1a4i1p5HnhkG9OFymi0ReoO05cGwb+ayv4dysVygjeFmsP05f8wpZQ8fsdvfmuY9zjWSNqUtgYFVnOVReILYoBFzdQI5/GGFzNHhGbeZnopDGU29sZbscgldmC99w35VOATTycIMMcBXIfpSVGzZhA6C8hh00conln6VQ9TGgV32OEAKQC4DrBq7CJwd0ggR7Vq/rPrfgB+C3sGypY5DAAAAABJRU5ErkJggg=="
          alt=""
        />
      </button>
    </div>
  `,
  standalone: false,
})
export class BsTimepickerViewComponent {
  ampm = 'ok';
  hours = 0;
  minutes = 0;
}
